import { render, staticRenderFns } from "./RepoContent.vue?vue&type=template&id=652e6de8&"
import script from "./RepoContent.vue?vue&type=script&lang=js&"
export * from "./RepoContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports